"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.init = init;
exports.updateToken = updateToken;
exports.preventOnForbiddendHeader = exports.preventOnUnauthorizedHeader = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _netUtils = require("@onviobr/net-utils");

var _constants = require("../utils/constants");

var globalToken;
var globalScheme = 'UDSLongToken';
var preventOnUnauthorizedHeader = 'x-prevent-unauthorized';
exports.preventOnUnauthorizedHeader = preventOnUnauthorizedHeader;
var preventOnForbiddendHeader = 'x-prevent-forbidden';
exports.preventOnForbiddendHeader = preventOnForbiddendHeader;

function headerResolver(_url, options, headers) {
  var _context;

  var headersToUse = headers !== null && headers !== void 0 ? headers : options;
  var value = typeof globalToken === 'function' ? globalToken(_url, options, headers) : globalToken;
  return headersToUse.authorization || headersToUse.Authorization || (value ? (0, _concat.default)(_context = "".concat(globalScheme, " ")).call(_context, value) : null);
}

function init(_ref) {
  var token = _ref.token,
      authSchema = _ref.authSchema,
      onUnauthorized = _ref.onUnauthorized,
      onForbidden = _ref.onForbidden,
      domainAllowList = _ref.domainAllowList;
  globalToken = token;
  globalScheme = authSchema !== null && authSchema !== void 0 ? authSchema : globalScheme;
  var deregisters = [];

  if (globalToken) {
    var _context2;

    deregisters.push((0, _netUtils.injectHeaders)({
      authorization: headerResolver
    }, (0, _concat.default)(_context2 = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context2, (0, _toConsumableArray2.default)(domainAllowList !== null && domainAllowList !== void 0 ? domainAllowList : []))));
  }

  if (onUnauthorized || onForbidden) {
    var _context3;

    deregisters.push((0, _netUtils.addHttpRejectInterceptor)(function (_ref2, _ref3) {
      var url = _ref2.url;
      var statusText = _ref3.statusText,
          status = _ref3.status,
          headers = _ref3.headers;

      if (status === 401 && !(0, _includes.default)(url).call(url, preventOnUnauthorizedHeader) && onUnauthorized) {
        onUnauthorized({
          url: url,
          statusText: statusText,
          status: status,
          headers: headers
        });
      }

      if (status === 403 && !(0, _includes.default)(url).call(url, preventOnForbiddendHeader) && onForbidden) {
        onForbidden({
          url: url,
          statusText: statusText,
          status: status,
          headers: headers
        });
      }
    }, (0, _concat.default)(_context3 = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context3, (0, _toConsumableArray2.default)(domainAllowList !== null && domainAllowList !== void 0 ? domainAllowList : []))));
  }

  return function () {
    return (0, _forEach.default)(deregisters).call(deregisters, function (fn) {
      return fn();
    });
  };
}

function updateToken(token) {
  var scheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalScheme;
  globalToken = token;
  globalScheme = scheme;
}
